/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterWSmall = createReactComponent("letter-w-small", "IconLetterWSmall", [
  ["path", { d: "M9 8l1 8l2 -5l2 5l1 -8", key: "svg-0" }]
]);

export { IconLetterWSmall as default };
//# sourceMappingURL=IconLetterWSmall.js.map
